'use client'

import { useEffect } from 'react'

import { useNavigation } from '@features/navigation.hooks/useNavigation'
import { usePathname } from 'next/navigation'

import { ApiReferenceSharedNavigation } from '../ApiReferenceSharedNavigation/ApiReferenceSharedNavigation'

import type { ApiReferenceChildProps } from '../ApiReferenceNavigation'

/**
 * ApiReferenceNavigation component for mobile.
 */
export const ApiReferenceMobileNavigation = (props: ApiReferenceChildProps) => {
  const [showNavigation, setShowNavigation] = useNavigation()
  const pathname = usePathname()

  useEffect(() => {
    setShowNavigation(false)
  }, [pathname, setShowNavigation])

  if (!showNavigation) return null

  return (
    <div
      className="fixed bottom-0 left-0 top-header z-30 w-full overflow-y-auto bg-white p-6 md:hidden lg:hidden"
      data-testid="api-reference-mobile-navigation"
    >
      <ApiReferenceSharedNavigation {...props} />
    </div>
  )
}
